<template>
  <div>
    <template v-for="option in formattedCategories">
      <FacetOption
        :key="option.value"
        :label="option.label"
        :count="option.qty"
        :selected="isCategorySelected(option.value)"
        @toggle="
          selectCategory(isCategorySelected(option.value), {
            type: 'hierarchicalCategories.lvl0',
            value: option.value
          })
        "
      />
      <template v-if="isCategorySelected(option.value)">
        <FacetOption
          v-for="subcategory in subcategoriesFor(option.value)"
          :key="subcategory.value"
          nested
          :label="subcategory.label"
          :count="subcategory.qty"
          :selected="isSubcategorySelected(subcategory.value)"
          @toggle="
            selectSubcategory(isSubcategorySelected(subcategory.value), {
              type: 'hierarchicalCategories.lvl1',
              value: subcategory.value
            })
          "
        />
      </template>
    </template>
  </div>
</template>
<script>
import FacetOption from "./FacetOption.vue";
import { byLabel } from "./facetLabels";

export default {
  name: "categoryFilter",
  components: { FacetOption },
  props: {
    categories: {
      type: Object,
      required: true
    },
    subcategories: {
      type: Object,
      required: true
    },
    selection: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showAll: false
    };
  },
  computed: {
    currentCategoriesSelected() {
      return this.selection
        .filter(item => item.type == "hierarchicalCategories.lvl0")
        .map(item => item.value);
    },
    currentSubcategoriesSelected() {
      return this.selection
        .filter(item => item.type == "hierarchicalCategories.lvl1")
        .map(item => item.value);
    },
    formattedCategories() {
      const keys = Object.keys(this.categories).sort(byLabel);
      return keys.map(item => {
        return {
          label: item,
          value: item,
          qty: this.categories[item]
        };
      });
    }
  },
  methods: {
    isCategorySelected(label) {
      return this.currentCategoriesSelected.includes(label);
    },
    isSubcategorySelected(value) {
      return this.currentSubcategoriesSelected.includes(value);
    },
    subcategoriesFor(category) {
      const keys = Object.keys(this.subcategories);
      const validKeys = keys
        .filter(key => key.startsWith(`${category} >`))
        .sort(byLabel);
      return validKeys.map(item => {
        return {
          label: item
            .split(`${category} >`)
            .pop()
            .trim(),
          value: item,
          qty: this.subcategories[item]
        };
      });
    },
    selectCategory(selected, selection) {
      if (selected) {
        // Al quitar una categoría, también se quitan sus subcategorías seleccionadas
        this.subcategoriesFor(selection.value)
          .filter(sub => this.isSubcategorySelected(sub.value))
          .forEach(sub => {
            this.$emit("removed", {
              type: "hierarchicalCategories.lvl1",
              value: sub.value
            });
          });
        this.$emit("removed", selection);
      } else {
        this.$emit("selected", selection);
      }
      this.showAll = false;
    },
    selectSubcategory(selected, selection) {
      if (selected) {
        this.$emit("removed", selection);
      } else {
        this.$emit("selected", selection);
      }
      this.showAll = false;
    }
  }
};
</script>
